import InputTypesEnum from '../../../../../Enums/InputTypesEnum';
import ThirdPartyJobPaymentsService from '../../../../../Services/ThirdParty/ThirdPartyJobPaymentsService';
import EvaluatorPaymentActionParamsItem from '../../../../Evaluator/EvaluatorAdmin/EvaluatorPayments/EvaluatorPaymentActionParamsItem';

export default class VoidAndSupressWindowDescription {
  static titleForCreate = 'Void and Supress';
  static titleForEdit = 'Void and Supress';
  static finishButtonLabel = 'Void and Supress';
  static itemType = EvaluatorPaymentActionParamsItem;
  static serviceFunction = (edited) => ThirdPartyJobPaymentsService.VoidAndSupress(edited);
  static waitForServiceFunction = () => false;
  static messageOnSuccess =
    'The Void and Supress process has been started. You will receive a notification about the result in your personal notification repository.';

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [{ fieldName: 'Reason', label: 'Comment', className: 'col-12', type: InputTypesEnum.TextBox }],
    },
  ];
}
